import "@arco-design/web-react/es/Badge/style";
import _Badge from "@arco-design/web-react/es/Badge";
import "@arco-design/web-react/es/Tag/style";
import _Tag from "@arco-design/web-react/es/Tag";
import { Colors } from '@/config';
import React from 'react'; // 1 和  2 两个值， 对应两个显示。

export function DisplayOppositeOption({
  value = 1,
  display = ['是', '否'],
  type = 'badge'
}) {
  const colors = [Colors.GREEN, Colors.RED];

  if (type === 'tag') {
    return /*#__PURE__*/React.createElement(_Tag, {
      color: colors[value - 1]
    }, display[value - 1]);
  }

  return /*#__PURE__*/React.createElement(_Badge, {
    color: colors[value - 1],
    text: display[value - 1]
  });
}